<template>
  <div class="verval">
    <statistik :value="statistik"></statistik>
    <!--daftar-->
    <v-card flat>
      <v-card-title class="py-1">
        <base-table-header
          :options="{ header: 'pa-0' }"
          btn-filter
          :btn-download="$allow('psp-peserta-pelaksana.download')"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
          @download="onDownloadList"
        >
          <template v-slot:toolbar>
            <v-select
              class="mr-2"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              multiple
              autofocus
              :style="{ maxWidth: maxWidth }"
              @change="fetchData"
            >
              <template v-slot:selection="{ item }">
                <v-chip small>Angkatan {{ item.value }}</v-chip>
              </template>
            </v-select>
            <v-btn depressed color="info" @click="addPeserta" v-if="$allow('psp-peserta-pelaksana.create')">
              <v-icon left>
                mdi-plus
              </v-icon>
              Pelaksana
            </v-btn>
          </template>
          <template v-slot:subtitle>
            <div class="subtitle-1 font-weight-medium black--text">
              Daftar Sekolah Penggerak
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <base-list-filter
          ref="filter"
          title="Pilih Filter Status"
          :filtered="filtered"
          :filters="formFilter"
          :paramsFilter="filters"
          @save="filterSave"
        />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-avatar class="mr-3" size="48">
                          <v-avatar color="secondary" size="65">
                            <v-icon dark>mdi-bank</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                            {{ $getDeepObj(item, 'sekolah.nama') || '-' }}
                          </div>
                          <div class="body-2 mt-1">
                            <template v-if="item.sekolah_id">
                              <span class="font-weight-medium">NPSN: </span>
                              {{ $getDeepObj(item, 'sekolah.npsn') || '-' }}
                              <br />
                            </template>
                            <template v-if="item.sekolah_id">
                              <span class="font-weight-medium">Status: </span>
                              {{ +$getDeepObj(item, 'sekolah.is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                              <br />
                            </template>
                          </div>
                          <div class="body-2 font-weight-regular">
                            <template v-if="item.sekolah_id">
                              <span>{{ $getDeepObj(item, 'sekolah.m_kota.keterangan') }}</span>
                              <br />Prov. {{ $getDeepObj(item, 'sekolah.m_propinsi.keterangan') }}
                            </template>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="9">
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <span class="grey--text mb-1" style="font-size: 13px">
                                Kepala Sekolah
                              </span>
                              <div class="font-weight-regular" style="font-size: 15px">
                                <b>
                                  {{ $getDeepObj(item, 'ptk.nama') || '-' }}
                                </b>
                                <div class="body-2 mt-1">
                                  <span class="font-weight-medium">No. UKG: </span>
                                  {{ $getDeepObj(item, 'ptk.no_ukg') || '-' }}
                                  <br />
                                  <span class="font-weight-medium">Status: </span>
                                  {{ getStatusKasek(item) }}
                                  <br />
                                  <v-icon
                                    v-if="$getDeepObj(item, 'ptk.no_hp')"
                                    class="mr-1"
                                    color="success"
                                    small
                                    dark
                                    left
                                    @click="onCall(item)"
                                  >
                                    mdi-whatsapp
                                  </v-icon>
                                  {{ $getDeepObj(item, 'ptk.no_hp') || '-' }}
                                  <br />
                                </div>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <span class="grey--text mb-1" style="font-size: 13px">
                                Pengawas Binaan
                              </span>
                              <div class="font-weight-regular" style="font-size: 15px">
                                <b>
                                  {{ $getDeepObj(item, 'sekolah_binaan.ptk.nama') || '-' }}
                                </b>
                                <div v-if="$getDeepObj(item, 'sekolah_binaan.ptk.nama')" class="body-2 mt-1">
                                  <span class="font-weight-medium">No. UKG: </span>
                                  {{
                                    $getDeepObj(item, 'sekolah_binaan.ptk.no_ukg') ||
                                      $getDeepObj(item, 'sekolah_binaan.ptk.ptk_id') ||
                                      '-'
                                  }}
                                  <br />
                                  <span class="font-weight-medium">NIP: </span>
                                  {{ $getDeepObj(item, 'sekolah_binaan.ptk.ptk_info_dapodik.nip') || '-' }}
                                  <br />
                                  <br />
                                </div>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <span class="grey--text" style="font-size: 13px">
                                Kesesuaian Dapodik
                              </span>
                              <div class="body-2 font-weight-regular">
                                <template v-if="item.is_sesuai_dapodik">
                                  <div>
                                    <v-chip color="success" small>Sesuai</v-chip>
                                  </div>
                                </template>
                                <template v-else>
                                  <div>
                                    <v-chip color="error" small>Tidak Sesuai</v-chip>
                                  </div>
                                  <div v-if="(item.ptk_tugases || []).length" class="mt-1">
                                    <b>
                                      {{
                                        $getDeepObj((item.ptk_tugases && item.ptk_tugases[0]) || {}, 'ptk.nama') || '-'
                                      }}
                                    </b>
                                    <div class="body-2">
                                      <span class="font-weight-medium">No. UKG: </span>
                                      {{
                                        $getDeepObj((item.ptk_tugases && item.ptk_tugases[0]) || {}, 'ptk.no_ukg') ||
                                          '-'
                                      }}
                                    </div>
                                    <div class="body-2">
                                      <span class="font-weight-medium">Status: </span>
                                      {{
                                        $getDeepObj((item.ptk_tugases && item.ptk_tugases[0]) || {}, 'k_tugas')
                                          ? +$getDeepObj((item.ptk_tugases && item.ptk_tugases[0]) || {}, 'k_tugas') ===
                                            2
                                            ? 'Definitif'
                                            : 'PLT (Pelaksana Tugas)'
                                          : '-'
                                      }}
                                    </div>
                                  </div>
                                  <div v-else-if="jenisKasekNonSaminkal(item, item.ptk_sekolahs).length">
                                    <div class="orange--text mt-2" style="font-size: 12px">
                                      KS Tidak Menjabat di Satminkal
                                    </div>
                                    <div
                                      v-for="(ptkSekolah, id) in jenisKasekNonSaminkal(item, item.ptk_sekolahs)"
                                      :key="`ns-${id}`"
                                      class="mt-1"
                                    >
                                      <b>
                                        {{ $getDeepObj(ptkSekolah, 'ptk.nama') || '-' }}
                                      </b>
                                      <div class="body-2">
                                        <span class="font-weight-medium">No. UKG: </span>
                                        {{ $getDeepObj(ptkSekolah, 'ptk.no_ukg') || '-' }}
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else-if="(item.ptk_sekolahs || []).length">
                                    <div class="orange--text mt-2" style="font-size: 12px">
                                      Tugas Tambahan KS Belum Diset
                                    </div>
                                    <div v-for="(ptkSekolah, id) in item.ptk_sekolahs" :key="`ps-${id}`" class="mt-1">
                                      <b>
                                        {{ $getDeepObj(ptkSekolah, 'ptk.nama') || '-' }}
                                      </b>
                                      <div class="body-2">
                                        <span class="font-weight-medium">No. UKG: </span>
                                        {{ $getDeepObj(ptkSekolah, 'ptk.no_ukg') || '-' }}
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="orange--text mt-2" style="font-size: 12px">Tidak ada jabatan KS</div>
                                  </div>
                                </template>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <span class="grey--text" style="font-size: 13px">Angkatan</span>
                              <div class="subtitle-1 font-weight-medium secondary--text">
                                {{ item.gelombang || '-' }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <span class="grey--text" style="font-size: 13px">
                                Status
                              </span>
                              <div>
                                <v-chip small v-if="+item.is_aktif === 1" :class="['green', 'white--text']">
                                  Pelaksana
                                </v-chip>
                                <template v-else>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip small v-bind="attrs" v-on="on" :class="['red white--text']">
                                        Non Aktif
                                      </v-chip>
                                    </template>
                                    <span> alasan: {{ item.alasan }} </span>
                                  </v-tooltip>
                                  <div class="py-2 error--text caption">
                                    oleh {{ $getDeepObj(item, 'akun.nama') || '-' }}<br />
                                    {{
                                      $localDate(
                                        $normalizeTime($getDeepObj(item, 'updated_at') || ''),
                                        false,
                                        true,
                                        true
                                      )
                                    }}
                                  </div>
                                </template>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text v-if="actionsMenu.length">
                  <base-list-action :data="item" :actions="actionsMenu" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <!--modal-->
    <base-modal-full
      ref="modal"
      :auto-close="formulir['autoClose']"
      :title="formulir['title']"
      :use-save="!formulir['preview']"
      @close="onClose"
      @save="onSave"
    >
      <component
        ref="formulir"
        :is="formulir['form']"
        :jenis="formulir['jenis']"
        :id="formulir['id']"
        :preview="formulir['preview']"
        :detail="formulir['detail']"
        :masters="Object.assign({}, formulir['masters'])"
      ></component>
    </base-modal-full>
  </div>
</template>

<script>
import list from '@mixins/list';
import Statistik from './Statistik';
import FormAjuan from './FormAjuan';
import FormPeserta from './FormPeserta';
import FormStatus from './FormStatus';
import BaseChips from '@components/base/BaseChips';
import mixin from '../mixin';
import actionsMenu from '../actions';
import { mapActions } from 'vuex';
export default {
  name: 'Sekolah',
  props: {
    jenis: {
      type: String,
      required: true,
    },
  },
  components: { BaseChips, Statistik, FormAjuan, FormPeserta, FormStatus },
  mixins: [list, mixin],
  data() {
    return {
      formulir: {},
      actionsMenu: actionsMenu['pelaksana'],
      listLaporan: [
        {
          key: 'download',
          label: `Laporan Daftar Peserta PSP`,
        },
      ],
      M_GUGUR: {
        1: 'Gugur',
        0: 'Tidak Gugur',
      },
      M_STATUS: {
        1: 'Pelaksana',
        0: 'Tidak Aktif',
      },
      M_STATUS_SESUAI: {
        1: 'Sesuai ',
        0: 'Tidak Sesuai',
      },
      M_STATUS_RIWAYAT: {
        1: 'Ada Riwayat Perubahan',
        0: 'Tidak Ada Riwayat Perubahan',
      },
      M_STATUS_NEGERI: {
        1: 'Negeri ',
        0: 'Swasta',
      },
    };
  },
  created() {
    this.attr = { api: this.$route.meta.api || '' };
  },
  mounted() {
    this.$set(this.params, 'gelombang', [this.$getDeepObj(this.pspConfig, `peringkat.gelombang`)]);
  },
  computed: {
    mGelombang() {
      // const result = [{ text: `Seluruh Angkatan`, value: '' }];
      const result = [];

      for (let i = Number(this.pspConfig['peringkat']['gelombang']); i > 0; i--) {
        result.push({ text: `Angkatan ${i}`, value: i });
      }

      return result;
    },
    maxWidth() {
      let start = 180;
      if (this.params && this.params.gelombang && this.params.gelombang.length > 1) {
        start = start + (this.params.gelombang.length - 1) * 80;
      }

      return `${start}px`;
    },
  },
  methods: {
    ...mapActions('pelaksana', ['fetch', 'getDetail', 'actions', 'mundur', 'downloadList']),

    jenisKasekNonSaminkal(pspPelaksana, ptkSekolahs = []) {
      return ptkSekolahs
        .filter((ptkSekolah) => ((ptkSekolah.ptk && ptkSekolah.ptk.ptk_tugases) || []).length)
        .filter(
          (ptkSekolah) =>
            ptkSekolah.ptk.ptk_tugases.filter((ptkTugas) => ptkTugas.sekolah_id !== pspPelaksana.sekolah_id).length
        );
    },

    getStatusKasek(pspPelaksana = {}) {
      const ptkTugases = (pspPelaksana.ptk && pspPelaksana.ptk.ptk_tugases) || [];
      const ptkTugas = this.$ptkTugas(ptkTugases, pspPelaksana.sekolah_id);

      return ptkTugas.k_tugas ? (+ptkTugas.k_tugas === 2 ? 'Definitif' : 'PLT (Pelaksana Tugas)') : '-';
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
